import React from 'react';

import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';

interface CustomTooltipProps extends TooltipProps {
    customStyles?: React.CSSProperties;
}

const CustomTooltip = styled(({ className, customStyles, ...props }: CustomTooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))
    (({ theme, customStyles }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            ...customStyles
        },
    }));

export default CustomTooltip;